<template>
  <div id="image-to-tap">
    <div
      v-if="wrongOrientation"
      class="please-rotate notification is-primary">
      {{ $t("common.pleaseRotate1") }} <strong>{{ $t("common.pleaseRotate2") }}</strong><br/><br/><br/>
      {{ $t("common.pleaseRotate3") }}
    </div>
    <div
      v-if="!wrongOrientation">
      <div id="scrollable-icon" v-if="scrollable">
        <i class="fas fa-up-down-left-right"></i>
      </div>
      <div id="floating-text" v-if="attributes.floatingText">
        {{ attributes.floatingText }}
      </div>
      <div id="wrong-answer" v-if="wrongAnswer">
        {{ $t("scene.imagetotap.nope") }}
        <span v-if="attributes.penalty">
          <br/>
          ({{ $t("common.penalty") }} + {{ attributes.penalty }}s)
        </span>
      </div>
      <div class="parent" :style="{'width': imageWidth + 'px', 'height': imageHeight + 'px'}">
        <img :src="attributes.url" ref="theImg" @click="onClick" class="child"/>
      </div>
    </div>
  </div>
</template>

<script>
import PuzzleMixin from '@/mixins/Puzzle'
import ForceOrientationMixin from '@/mixins/ForceOrientation'

export default {
  name: 'ImageToTapMixin',
  mixins: [PuzzleMixin, ForceOrientationMixin],
  props: ['attributes', 'number'],
  data () {
    return {
      wrongAnswer: false,
      imageWidth: 0,
      imageHeight: 0
    }
  },
  computed: {
    scrollable () {
      return this.attributes.scrollable
    }
  },
  mounted () {
    if (this.attributes.initialScrollTo) {
      const theImg = this.$refs.theImg
      const scrollableParent = theImg.closest('.scrollable-zone')
      const x = this.attributes.initialScrollTo.x
      const y = this.attributes.initialScrollTo.y
      theImg.onload = function () {
        scrollableParent.scrollLeft = x
        scrollableParent.scrollTop = y
      }
    }
    const component = this
    if (this.attributes.tappedImageFile) {
      const img = new Image()
      img.onload = function () {
        component.tappedImageFileWidth = this.width
        component.tappedImageFileHeight = this.height
      }
      img.src = this.attributes.tappedImageFile
    }
    const mainImg = new Image()
    mainImg.onload = function () {
      component.imageWidth = this.width
      component.imageHeight = this.height
    }
    mainImg.src = this.attributes.url
    this.onForceOrientationResize()
    window.addEventListener('resize', this.onForceOrientationResize, false)
  },
  unmounted () {
    window.removeEventListener('resize', this.onForceOrientationResize)
  },
  methods: {
    onClick (evt) {
      const choices = this.attributes.choices
      const correctChoice = this.attributes.correctChoice

      this.lastClickLeft = evt.offsetX
      this.lastClickTop = evt.offsetY

      for (const choice of choices) {
        if (evt.offsetX >= choice.x && evt.offsetX <= choice.x + choice.width && evt.offsetY >= choice.y && evt.offsetY <= choice.y + choice.height) {
          // Clicked on some item
          if (choice.key === correctChoice) {
            // Success
            this.playVictorySound()
            this.$store.dispatch('validateItem', {
              number: this.number
            })
          } else {
          // Failure
            this.wrongAnswer = true
            const component = this
            setTimeout(function () {
              component.wrongAnswer = false
            }, 3000)
            if (this.attributes.penalty) {
              this.$store.dispatch('addTimePenalty', {
                seconds: this.attributes.penalty
              })
            }
            this.playFailedSound()
          }
        }
      }
    }
  }
}
</script>

<style lang="sass">

#image-to-tap

  .please-rotate
    margin-top: 150px

  #scrollable-icon
    position: absolute
    width: 100%
    text-align: center
    opacity: 0.3
    margin-top: 60px
    pointer-events: none
    z-index: 100
    .fa-up-down-left-right
      font-size: 80px
      color: #844
      pointer-events: none

  #floating-text
    position: absolute
    pointer-events: none
    width: 25%
    top: 50px
    text-align: center
    opacity: 0.8
    font-size: 14px
    padding: 10px
    color: rgba(255, 255, 255, 0.9)
    font-weight: 600
    z-index: 4
    background-color: rgba(86, 43, 170, 0.3)

  #wrong-answer
    position: absolute
    pointer-events: none
    left: 25%
    right: 25%
    top: 100px
    z-index: 10000
    text-align: center
    opacity: 0.8
    padding: 10px 30px
    color: rgba(255, 255, 255, 0.9)
    font-weight: 600
    background-color: rgba(255, 0, 0, 0.6)

  .parent
    display: flex
    position: relative
    z-index: 2
    margin: auto

  .parent:after
    content: ""
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    z-index: 2

  .child
    position: absolute
    max-width: 100%
    max-height: 100%
    z-index: 3

</style>
